<template>
  <div class="indicadores-layout">
    <nav class="indicadores-sidebar">
      <ul class="indicadores-nav">
        <li>
          <button
            class="button-71"
            :class="{ selected: selectedSection === 'resumen' }"
            @click="selectSection('resumen')"
          >
            Resumen
          </button>
        </li>
        <li>
          <button
            class="button-71"
            :class="{ selected: selectedSection === 'fecha' }"
            @click="selectSection('fecha')"
          >
            Indicador Fecha
          </button>
        </li>
      </ul>
    </nav>
    <div class="indicadores-content">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script>
import ResumenIndicadores from './ResumenIndicadores.vue';
import IndicadorFecha from './IndicadorFecha.vue';
import apiClient from '@/api/index';

export default {
  name: 'IndicadoresIndex',
  components: {
    ResumenIndicadores,
    IndicadorFecha,
  },
  data() {
    return {
      selectedSection: 'resumen',
      codigosDisponibles: [],
    };
  },
  computed: {
    currentComponent() {
      return this.selectedSection === 'resumen' ? 'ResumenIndicadores' : 'IndicadorFecha';
    },
  },
  mounted() {
    this.fetchCodigos();
  },
  methods: {
    selectSection(section) {
      this.selectedSection = section;
    },
    async fetchCodigos() {
      try {
        const res = await apiClient.get('/indicadores/codigos');
        this.codigosDisponibles = res.data;
      } catch {
        this.codigosDisponibles = [];
      }
    },
  },
  provide() {
    // Provide codigosDisponibles as a function for reactivity
    return {
      codigosDisponibles: () => this.codigosDisponibles,
      fetchCodigos: this.fetchCodigos,
    };
  },
};
</script>

<style scoped>
.indicadores-layout {
  display: flex;
  min-height: 100vh;
}
.indicadores-sidebar {
  width: 260px;
  min-width: 220px;
  background: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 1em 1em 1em;
  gap: 2em;
  height: 100vh;
  box-sizing: border-box;
}
.indicadores-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.indicadores-nav li {
  display: block;
  width: 100%;
}
.indicadores-content {
  margin-top: 1rem;
  flex: 1;
  padding: 2em 2em 2em 2em;
}
.button-71 {
  background-color: #0078d4;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 0.5px 1.5px rgba(0,0,0,0.08);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7em 1.5em;
  margin: 0.2em 0;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  outline: none;
  width: 100%;
  text-align: left;
  width:12em;
}
.button-71.selected {
  background-color: #22c55e !important;
  color: #fff;
  box-shadow: 0 4px 12px rgba(34,197,94,0.15);
  transform: scale(1.0);
}
.button-71:hover, .button-71:focus {
  background-color: #005fa3;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12), 0 1.5px 3px rgba(0,0,0,0.12);
  transform: translateY(-2px) scale(1.03);
}
.button-71:active {
  background-color: #004c87;
  box-shadow: 0 1px 2px rgba(0,0,0,0.10);
  transform: none;
}
.indicadores-content {
  flex: 1;
  padding: 2em;
}
.csb-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}
.csb-table thead {
  background-color: #333;
  color: #fff;
}
.csb-table th, .csb-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.csb-table th {
  font-weight: bold;
}
.csb-table .odd-row {
  background-color: #f9f9f9;
}
.csb-table .even-row {
  background-color: #fff;
}
.clickable-header {
  cursor: pointer;
  text-decoration: underline;
  color: #0078d4;
  transition: color 0.2s;
}
.clickable-header:hover {
  color: #22c55e;
}
.white-header {
  color: #fff !important;
}
.codigo-dropdown {
  min-width: 140px;
  padding: 0.4em 0.7em;
  border-radius: 6px;
  border: 1px solid #bbb;
  font-size: 1em;
  margin-left: 0.5em;
}
.csb-table-wrapper {
  width: 50%;
  margin-left: 0;
  margin-right: auto;
}
.left-indented {
  text-align: left;
  margin-left: 2em;
}
.left-indented-row {
  justify-content: flex-start !important;
  gap: 2em;
}
</style>